import type {
  StaffAttendanceRecord,
  StaffAttendanceStatus,
  StaffAttendanceSummary,
} from '../types/hrmsAttendanceRecords.types'

export const PAGE_SIZE = 10

export const MOCK_STAFF_ATTENDANCE_SUMMARY: StaffAttendanceSummary = {
  present: 224,
  late: 14,
  absent: 10,
}



export const ATTENDANCE_STATUS_OPTIONS = [
  { label: 'All Statuses', value: 'All Statuses' },
  { label: 'Present', value: 'Present' },
  { label: 'Late', value: 'Late' },
  { label: 'Absent', value: 'Absent' },
  { label: 'On Leave', value: 'On Leave' },
]

const FIRST_NAMES = [
  'Amit',
  'Deepak',
  'Sanjay',
  'Vikram',
  'Rohan',
  'Neelam',
  'Sunita',
  'Pooja',
  'Rajesh',
  'Manish',
  'Kiran',
  'Aarti',
  'Geeta',
  'Vijay',
  'Alok',
  'Ritu',
  'Nisha',
  'Tarun',
  'Shalini',
  'Ramesh',
  'Harish',
  'Preeti',
  'Swati',
  'Ganesh',
]

const LAST_NAMES = [
  'Verma',
  'Singh',
  'Gupta',
  'Patel',
  'Rao',
  'Nair',
  'Reddy',
  'Chawla',
  'Joshi',
  'Bhasin',
  'Mehta',
  'Kulkarni',
  'Deshmukh',
  'Saxena',
  'Pandey',
  'Mishra',
]

const DESIGNATIONS = [
  'Senior Faculty',
  'Assistant Professor',
  'Associate Lecturer',
  'Lab Instructor',
  'Reader & HOD',
  'Lecturer',
  'Primary Coordinator',
  'System Admin',
  'Librarian',
  'Accountant',
]

const DEPARTMENTS = [
  'Mathematics',
  'Science',
  'English',
  'Computer Science',
  'Administration',
  'Social Science',
  'Physical Education',
  'Languages (Tamil)',
  'Primary Wing',
  'Accounts',
  'Library',
  'IT & Support',
]

function generateMockRecords(): StaffAttendanceRecord[] {
  const initialRecords: StaffAttendanceRecord[] = [
    {
      id: 'rec-1',
      name: 'Anitha Kumar',
      designation: 'Senior Faculty',
      employeeId: 'EMP-1028',
      department: 'Mathematics',
      checkIn: '09:02',
      checkOut: '17:58',
      workingMinutes: 536,
      status: 'Present',
      source: 'Biometric',
    },
    {
      id: 'rec-2',
      name: 'Rahul Kumar',
      designation: 'Associate Lecturer',
      employeeId: 'EMP-7712',
      department: 'Science',
      checkIn: '09:18',
      checkOut: undefined,
      workingMinutes: 252,
      status: 'Present',
      source: 'Biometric',
    },
    {
      id: 'rec-3',
      name: 'Priya Sharma',
      designation: 'Assistant Professor',
      employeeId: 'EMP-4909',
      department: 'English',
      checkIn: undefined,
      checkOut: undefined,
      workingMinutes: undefined,
      status: 'On Leave',
      source: null,
    },
    {
      id: 'rec-4',
      name: 'Arun Kumar',
      designation: 'Lab Instructor',
      employeeId: 'EMP-9034',
      department: 'Computer Science',
      checkIn: '09:45',
      checkOut: undefined,
      workingMinutes: 220,
      status: 'Late',
      source: 'Biometric',
    },
    {
      id: 'rec-5',
      name: 'Meena Devi',
      designation: 'Administrative Officer',
      employeeId: 'EMP-5180',
      department: 'Administration',
      checkIn: undefined,
      checkOut: undefined,
      workingMinutes: undefined,
      status: 'Absent',
      source: null,
    },
    {
      id: 'rec-6',
      name: 'Suresh Kumar',
      designation: 'Reader & HOD',
      employeeId: 'EMP-4211',
      department: 'Mathematics',
      checkIn: '08:55',
      checkOut: '18:02',
      workingMinutes: 547,
      status: 'Present',
      source: 'Manual Import',
    },
    {
      id: 'rec-7',
      name: 'Karthik Raja',
      designation: 'Lecturer',
      employeeId: 'EMP-1025',
      department: 'Languages (Tamil)',
      checkIn: '08:40',
      checkOut: '17:15',
      workingMinutes: 515,
      status: 'Present',
      source: 'Biometric',
    },
    {
      id: 'rec-8',
      name: 'Kavita Balan',
      designation: 'Primary Coordinator',
      employeeId: 'EMP-1035',
      department: 'Primary Wing',
      checkIn: '08:52',
      checkOut: undefined,
      workingMinutes: 268,
      status: 'Present',
      source: 'Biometric',
    },
  ]

  const records: StaffAttendanceRecord[] = [...initialRecords]

  for (let i = 9; i <= 248; i++) {
    const fn = FIRST_NAMES[(i * 7) % FIRST_NAMES.length]
    const ln = LAST_NAMES[(i * 11) % LAST_NAMES.length]
    const name = `${fn} ${ln}`
    const designation = DESIGNATIONS[(i * 3) % DESIGNATIONS.length]
    const department = DEPARTMENTS[i % DEPARTMENTS.length]
    const employeeId = `EMP-${2000 + i}`

    let status: StaffAttendanceStatus = 'Present'
    let source: StaffAttendanceRecord['source'] = 'Biometric'
    let checkIn: string | undefined = '08:50'
    let checkOut: string | undefined = '17:30'
    let workingMinutes: number | undefined = 520

    if (i % 23 === 0) {
      status = 'Absent'
      source = null
      checkIn = undefined
      checkOut = undefined
      workingMinutes = undefined
    } else if (i % 29 === 0) {
      status = 'On Leave'
      source = null
      checkIn = undefined
      checkOut = undefined
      workingMinutes = undefined
    } else if (i % 17 === 0) {
      status = 'Late'
      source = 'Biometric'
      checkIn = '09:35'
      checkOut = '17:30'
      workingMinutes = 475
    } else if (i % 19 === 0) {
      status = 'Present'
      source = 'Manual Import'
      checkIn = '09:00'
      checkOut = '17:30'
      workingMinutes = 510
    }

    records.push({
      id: `rec-${i}`,
      name,
      designation,
      employeeId,
      department,
      checkIn,
      checkOut,
      workingMinutes,
      status,
      source,
    })
  }

  return records
}

export const MOCK_STAFF_ATTENDANCE_RECORDS = generateMockRecords()
